export default function Problem() {
  const problems = [
    {
      icon: 'ri-question-line',
      title: 'No Consistent Communication',
      description: 'Customers only hear from you during inspections or emergencies.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Out of Sight, Out of Mind',
      description: 'Customers forget who services their systems until something breaks.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitors Underbid',
      description: 'Without relationship equity, price becomes the only differentiator.'
    },
    {
      icon: 'ri-user-line',
      title: 'No Personality',
      description: 'Your company feels like every other contractor in the industry.'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'No Differentiation',
      description: 'Nothing sets you apart from the competition in a crowded market.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'No Retention Strategy',
      description: 'Hoping referrals and word-of-mouth will keep the pipeline full.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Most Fire Protection Companies Rely on Referrals. And Hope.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Without a consistent communication strategy, you're invisible between service calls.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-lg mb-6">
                <i className={`${problem.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{problem.title}</h3>
              <p className="text-gray-600 leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-red-50 border-l-4 border-red-600 p-6 rounded-lg">
            <p className="text-lg text-gray-800 font-medium">
              <strong>The result?</strong> Lost service agreements, price-shopping customers, and a business that depends entirely on referrals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}